import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CometChat } from '@cometchat-pro/chat';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUser: any;

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router,
    private _httpClient: HttpClient,
    private messageService: MessageService
  ) {}

  doLogin(email, password): void {
    this.afAuth.signInWithEmailAndPassword(email, password).then(
      async (res) => {
        await this.loginCometChat();
        this.router.navigateByUrl('/content');
      },
      (err) => {
        this.showLoginError(err);
      }
    );
  }

  doPhoneVerify(verificationId, code): void {
    const credential = firebase.auth.PhoneAuthProvider.credential(
      verificationId,
      code
    );
    this.afAuth.signInWithCredential(credential).then(
      async (res) => {
        await this.loginCometChat();
        this.router.navigateByUrl('/content/patients');
      },
      (err) => {
        this.showLoginError(err);
      }
    );
  }

  private async loginCometChat() {
    let uid = '786786';
    const authKey = environment.AUTH_KEY;
    try {
      // const user = new CometChat.User(uid);
      // user.setName(localStorage.getItem('name'));
      // await CometChat.createUser(user, authKey);
      await CometChat.login(uid, authKey);
      return;
    } catch (error) {
      await CometChat.login(uid, authKey);
      return;
    }
  }

  doLogout(): Promise<any> {
    localStorage.clear();
    return new Promise((resolve, reject) => {
      if (firebase.auth().currentUser) {
        this.afAuth.signOut();
        resolve({});
      } else {
        reject();
      }
    });
  }

  signUp(email, password): Promise<any> {
    return this.afAuth
      .createUserWithEmailAndPassword(email, password)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        window.alert(error.message);
      });
  }

  setCurrentUser(user: firebase.User | any): void {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUser = user;

    const currentFSUser = firebase.auth().currentUser;
    if (currentFSUser) {
      currentFSUser.getIdToken().then((resp) => {
        this.currentUser.authType = 'Bearer';
        this.currentUser.authToken = resp;
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      });
    }
  }

  getCurrentUser(): any {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return this.currentUser;
  }

  getAuthToken(): string {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (this.currentUser && this.currentUser.authToken) {
      return this.currentUser.authToken;
    }

    return '';
  }

  refreshToken(): Promise<any> {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const currentFSUser = firebase.auth().currentUser;
    if (currentFSUser) {
      return currentFSUser.getIdToken(true).then((resp) => {
        this.currentUser.authType = 'Bearer';
        this.currentUser.authToken = resp;
        return this.currentUser;
      });
    } else {
      return Promise.reject(null);
    }
  }

  showLoginError(err): void {
    let msg;
    switch (err.code) {
      case 'auth/wrong-password': {
        msg = 'The password supplied was not correct.';
        break;
      }
      case 'auth/invalid-email': {
        msg = 'The email address provided is not valid.';
        break;
      }
      case 'auth/user-not-found': {
        msg = 'We do not recognize your userId / email.';
        break;
      }
      case 'auth/user-disabled': {
        msg =
          'Your account is disabled. Please send an email to info@phlotilla.com.';
        break;
      }
      default: {
        msg = err.message;
        break;
      }
    }
    this.messageService.add({
      key: 'modal',
      severity: 'warn',
      summary: 'Login Error',
      detail: msg,
      life: 6000,
      data: {
        onConfirm: this.onTryAgain.bind(this),
        confirmBtnLabel: 'Try Again',
      },
    });
  }

  onTryAgain(): void {
    this.messageService.clear('modal');
  }
  
  createAuth(data: {
    email: string;
    password: string;
    phoneNumber: string;
    fullName: string;
  }): Observable<any> {
    return this._httpClient.post<any>(
      `${environment.firebase.cloudFunctionUrl}/app/api/users`,
      data
    );
  }
}
